<template>
  <span>
    <v-tooltip bottom v-if="hasBLE">
      <v-btn
        :color="inverted ? 'white' : 'primary'"
        icon
        height="30"
        slot="activator"
        @click="showBleModal"
      >
        <v-icon :color="inverted ? 'primary' : 'white'">bluetooth</v-icon>
      </v-btn>
      <span v-html="$t('parkingDetail.tooltip.ble')"></span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasCamara">
      <v-btn
        :color="inverted ? 'white' : 'primary'"
        icon
        height="30"
        slot="activator"
        @click="showCamaraModal"
      >
        <v-icon :color="inverted ? 'primary' : 'white'">videocam</v-icon>
      </v-btn>
      <span v-html="$t('parkingDetail.tooltip.camara')"></span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasRFID">
      <v-btn
        :color="inverted ? 'white' : 'primary'"
        icon
        height="30"
        slot="activator"
        @click="showRfidModal"
      >
        <v-icon :color="inverted ? 'primary' : 'white'">wifi</v-icon>
      </v-btn>
      <span v-html="$t('parkingDetail.tooltip.rfid')"></span>
    </v-tooltip>
    <v-tooltip bottom v-if="hasElectricSpots">
      <v-btn
        :color="inverted ? 'white' : 'primary'"
        icon
        height="30"
        slot="activator"
        @click="showElectricModal"
      >
        <v-icon :color="inverted ? 'primary' : 'white'">bolt</v-icon>
      </v-btn>
      <span v-html="$t('parkingAccessType.electric.title')"></span>
    </v-tooltip>

    <information-ble-modal @on-close="onCloseModal" v-if="isShowingBleModal">
    </information-ble-modal>

    <information-camara-modal
      @on-close="onCloseModal"
      v-if="isShowingCamaraModal"
    >
    </information-camara-modal>

    <information-rfid-modal @on-close="onCloseModal" v-if="isShowingRfidModal">
    </information-rfid-modal>

    <information-electric-modal
      @on-close="onCloseModal"
      v-if="isShowingElectricModal"
      :electric-info="electricInfo"
    >
    </information-electric-modal>
  </span>
</template>

<script>
import store from '@/store';
import InformationBleModal from './InformationBleModal.vue';
import InformationCamaraModal from './InformationCamaraModal.vue';
import InformationRfidModal from './InformationRfidModal.vue';
import InformationElectricModal from './InformationElectricModal.vue';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  components: {
    InformationBleModal,
    InformationCamaraModal,
    InformationRfidModal,
    InformationElectricModal,
  },
  name: 'ParkingEntryButtons',
  props: {
    parking: {
      type: Object,
      required: true,
    },
    inverted: false,
  },
  computed: {
    isLogged() {
      return store.state.isLogged;
    },
  },
  created() {
    EventBus.$on(keys.eventShowElectricModal, this.showElectricModal);
  },
  watch: {
    parking: function (value) {
      if (typeof value === 'undefined') {
        this.hasBLE = false;
        this.hasCamara = false;
        this.hasRFID = false;
        this.hasElectricSpots = false;
        return;
      }
      this.hasBLE = this.isLogged && value.hasBLE && !value.isFacility;
      this.hasRFID = this.isLogged && value.hasRFID && !value.isFacility;
      this.hasCamara = this.isLogged && value.hasCamara;
      this.hasElectricSpots = this.isLogged && value.hasElectricSpots;
      this.electricInfo = value.description.electric;
    },
  },
  data() {
    return {
      isShowingBleModal: false,
      isShowingCamaraModal: false,
      isShowingRfidModal: false,
      isShowingElectricModal: false,
      hasBLE: false,
      hasCamara: false,
      hasRFID: false,
      hasElectricSpots: false,
      electricInfo: '',
    };
  },
  methods: {
    onCloseModal() {
      this.isShowingBleModal = false;
      this.isShowingCamaraModal = false;
      this.isShowingRfidModal = false;
      this.isShowingElectricModal = false;
    },
    showBleModal() {
      this.isShowingBleModal = true;
    },
    showRfidModal() {
      this.isShowingRfidModal = true;
    },
    showElectricModal() {
      this.isShowingElectricModal = true;
    },
    showCamaraModal() {
      this.isShowingCamaraModal = true;
    },
  },
};
</script>
